// src/features/kpi/kpiSlice.js

import { createSlice } from "@reduxjs/toolkit";
import { fetchWaagData, fetchWaagDataByDateRange } from "../thunks/waagThunk";

const initialState = {
  data: null,
  dateRangeData: null,
  loading: "idle",
  error: null,
};

const waagSlice = createSlice({
  name: "waag",
  initialState,
  reducers: {
    clearWaagData: (state) => {
      state.dateRangeData = null;
    },
  },
  extraReducers: (builder) => {
    builder
      .addCase(fetchWaagData.pending, (state) => {
        state.loading = "loading";
      })
      .addCase(fetchWaagData.fulfilled, (state, action) => {
        state.loading = "succeeded";
        state.data = action.payload;
        state.error = null;
      })
      .addCase(fetchWaagData.rejected, (state, action) => {
        state.loading = "failed";
        state.error = action.error.message;
      })
      .addCase(fetchWaagDataByDateRange.pending, (state) => {
        state.loading = "loading";
      })
      .addCase(fetchWaagDataByDateRange.fulfilled, (state, action) => {
        state.loading = "succeeded";
        state.dateRangeData = action.payload;
        state.error = null;
      })
      .addCase(fetchWaagDataByDateRange.rejected, (state, action) => {
        state.loading = "failed";
        state.error = action.error.message;
      });
  },
});

export const { clearWaagData } = waagSlice.actions;
export default waagSlice.reducer;
